<template>
  <el-dialog
    top="10vh"
    title="数据说明"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="showModel"
  >
    <div class="title">统计时间（北京时间）</div>
    <div class="content">
      本平台于每日 01:00、07:00、13:00、19:00 四个时间段进行数据统计，其他时间 不统计。
    </div>
    <div class="title">统计范围</div>
    <div class="content">
      接入本平台的产品及设备，固件端每次上线或每隔24小时，会进行一次固件版本 号的查询确认。
    </div>
    <div class="title">失败说明</div>
    <div class="content">
      考虑到设备FOTA的稳定性和安全性，平台对并发的FOTA请求进行数量限制，会造成部分请求失效。但不影响设备下一次询问进行FOTA升级。
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    showModel: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('update:showModel', false)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  .el-dialog__body {
    padding: 20px;
  }
}
.title {
  margin-top: 24px;
  padding-left: 16px;
  width: 318px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  background-image: linear-gradient(270deg, rgba(51, 157, 255, 0) 0%, rgba(51, 157, 255, 0.2) 100%);
  border-radius: 7px 8px 8px 7px;
}
.content {
  margin-top: 8px;
  padding-left: 16px;
  line-height: 22px;
  font-size: 14px;
  color: #666666;
}
</style>
